export default __webpack_public_path__ + "static/hongKong-4c08f70a702bd5ee7225aca30982e490.svg";